import React, { Component } from 'react';
import withErrorCatcher from '../../components/Common/withErrorCatcher.js'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { DATA_UPDATED } from '../../../actionTypes/actionTypes.js';
import { initSubscriptionModal, openSubscriptionModal } from '../../../actions/upgradeSubscriptionActions.js';

export const widtherItem = 320
export const spaceBetweenItems = 37
export const gridwidtherItem = 4

class Library extends Component {

    state = {
        topics: [],
        openCollections: [],
        isLoading: true
    }
    openSubscriptionDialog = () => {
        const { dispatch } = this.props;
        dispatch(initSubscriptionModal({reason: 'library', mode: 'existed', allowClose: false}))
        dispatch(openSubscriptionModal())
    }

    canUseLibrary = () => {
        const { subscription } = this.props;
        if([0, 1].includes(subscription.subscriptionType)) return false
        return true
    }


    componentWillReceiveProps(nextProps) {
        const { dispatch, groupService, adminService, oldUiData } = nextProps
        if (oldUiData.needsUpdate) {
            Promise.all([
                adminService.getAllTopics(),
                groupService.getOpenCollections(),
            ]).then(vals => {
                this.setState({
                    topics: vals[0],
                    allCollections: this.allCollections(vals[1]),
                });
                dispatch({ type: DATA_UPDATED })
            })
        }
    }

    // concat close collections with open collections
    allCollections(openCollections) {
        const closeCollections = this.props.userData.collections

        // recive 2 collections and check if they the same
        const isSameCollection = (collection1, collection2) => collection1.collectionUid == collection2.collectionUid

        // filter the open collections those appear in the close collections
        const uniqeOpenCollections = openCollections.filter(openCollection =>
            closeCollections.every(closeCollection => !isSameCollection(closeCollection, openCollection)))

        // concat the collections
        const allCollections = closeCollections.concat(uniqeOpenCollections)

        return allCollections
    }

    componentDidMount() {
        const { queryService, adminService, groupService } = this.props;
        if(!this.canUseLibrary()) {
            this.openSubscriptionDialog()
        }
        Promise.all([
            adminService.getAllTopics(),
            groupService.getOpenCollections(),
        ]).then(vals => {
            this.setState({
                topics: vals[0],
                allCollections: this.allCollections(vals[1]),
                isLoading: false
            });
        })
    }

    render() {
        if (this.state.isLoading) {
            return null
        }
        
        const { classes, users, mappings, children, userData, filestack } = this.props;
        const childrenWithProps = React.Children.map(children, child =>
            React.cloneElement(child, {
                users,
                collections: userData.collections,
                allCollections: this.state.allCollections,
                topics: this.state.topics,
                filestack: filestack
            })
        );

        return childrenWithProps
    }
}

const mapStateToProps = (state) => ({
    userData: state.userData,
    users: state.globalData.users,
    filestack: state.globalData.filestack,
    oldUiData: state.oldUiData,
    subscription: state.globalData.currentSubscription,

    ...state.services
})

const mapDispatchToProps = dispatch => {
    return { dispatch: dispatch }
}

export default connect(mapStateToProps, mapDispatchToProps)(Library);
